// import { get, groupBy } from 'lodash';
// import { fullAppNavigation } from '../../../../shared/navigation';
import { get, groupBy, isArray, isEmpty, omit, pick } from 'lodash';
import { fullAppNavigation } from '../../../../shared/navigation';
import Functions from '../../../utils/Functions';
export const response = {
  responseDetails: {
    isAbandoned: false,
    loanNumber: '0123456789',
    borrowers: [{
      borrowerId: 'Borrower1',
      type: 'primary',
      firstName: 'Suzi',
      middleName: 'abc',
      lastName: 'Firstimer',
      suffixName: 'Mr',
      mobile: '8888888888',
      email: 'test@test.com',
      employmentAnnualIncomeAmount: '1234567.45',
      jointWith: 'Borrower1',
      maritalStatusType: 'Married',
      domesticRelationshipIndicator: false,
      domesticRelationshipType: '',
      domesticRelationshipStateCode: '',
      domesticRelationshipTypeOtherDescription: '',
      selfDeclaredMilitaryServiceIndicator: false,
      militaryStatusType: 'US Armed Forces',
      militaryServiceToDate: '2023-07-25',
      citizenshipResidencyType: 'unknown',
      fullName: 'Alternate Name',
      dependentCount: 3,
      dependents: [{
        dependentAgeYearsCount: 12
      }, {
        dependentAgeYearsCount: 5
      }, {
        dependentAgeYearsCount: 2
      }],
      alternatePhone: '1234567890',
      ssn: '123456789',
      borrowerBirthDate: '07/23/1967',
      residences: [{
        'type': 'present',
        'borrowerResidencyDurationYearsCount': 10,
        'borrowerResidencyDurationMonthsCount ': 120,
        'street': 'Dawes St',
        'unit': '',
        'cityName': 'Springfield',
        'stateCode': 'Massachusetts',
        'postalCode': '01109',
        'housingExpenseType': 'Rent',
        'housingExpensePaymentAmount': '1000'
      }, {
        'type': 'mail',
        'borrowerResidencyDurationYearsCount': 10,
        'borrowerResidencyDurationMonthsCount ': 120,
        'street': 'Dawes St',
        'unit': '',
        'cityName': 'Springfield',
        'stateCode': 'Massachusetts',
        'postalCode': '01109',
        'housingExpenseType': 'Rent',
        'housingExpensePaymentAmount': '1000'
      }, {
        'type': 'previous',
        'borrowerResidencyDurationYearsCount': 10,
        'borrowerResidencyDurationMonthsCount ': 120,
        'street': 'Dawes St',
        'unit': '',
        'cityName': 'Springfield',
        'stateCode': 'Massachusetts',
        'postalCode': '01109',
        'housingExpenseType': 'Rent',
        'housingExpensePaymentAmount': '1000'
      }, {
        'type': 'previous',
        'borrowerResidencyDurationYearsCount': 10,
        'borrowerResidencyDurationMonthsCount ': 120,
        'street': 'Dawes St',
        'unit': '',
        'cityName': 'Springfield',
        'stateCode': 'Massachusetts',
        'postalCode': '01109',
        'housingExpenseType': 'Rent',
        'housingExpensePaymentAmount': '1000'
      }]
    }, {
      borrowerId: 'Borrower2',
      type: 'co-borrower',
      firstName: 'Suzi',
      middleName: 'abc',
      lastName: 'Firstimer',
      suffixName: 'Mr',
      mobile: '',
      email: 'test@test.com',
      employmentAnnualIncomeAmount: 1234567.45,
      jointWith: 'Borrower1',
      maritalStatusType: 'Married',
      domesticRelationshipIndicator: 'No',
      domesticRelationshipType: '',
      domesticRelationshipStateCode: '',
      domesticRelationshipTypeOtherDescription: '',
      selfDeclaredMilitaryServiceIndicator: 'Yes',
      militaryStatusType: 'Active Duty',
      militaryServiceToDate: '7/3/2023',
      citizenshipResidencyType: 'unknown',
      fullName: 'Alternate Name',
      dependentCount: 3,
      dependents: [{
        dependentAgeYearsCount: 12
      }, {
        dependentAgeYearsCount: 5
      }, {
        dependentAgeYearsCount: 2
      }],
      alternatePhone: '1234567890',
      ssn: '123456789',
      borrowerBirthDate: '07/23/1967',
      residences: [{
        'type': 'present',
        'borrowerResidencyDurationYearsCount': 10,
        'borrowerResidencyDurationMonthsCount ': 120,
        'street': 'Dawes St',
        'unit': '',
        'cityName': 'Springfield',
        'stateCode': 'Massachusetts',
        'postalCode': '01109',
        'housingExpenseType': 'Rent',
        'housingExpensePaymentAmount': '1000'
      }, {
        'type': 'mail',
        'borrowerResidencyDurationYearsCount': 10,
        'borrowerResidencyDurationMonthsCount ': 120,
        'street': 'Dawes St',
        'unit': '',
        'cityName': 'Springfield',
        'stateCode': 'Massachusetts',
        'postalCode': '01109',
        'housingExpenseType': 'Rent',
        'housingExpensePaymentAmount': '1000'
      }, {
        'type': 'previous',
        'borrowerResidencyDurationYearsCount': 10,
        'borrowerResidencyDurationMonthsCount ': 120,
        'street': 'Dawes St',
        'unit': '',
        'cityName': 'Springfield',
        'stateCode': 'Massachusetts',
        'postalCode': '01109',
        'housingExpenseType': 'Rent',
        'housingExpensePaymentAmount': '1000'
      }]
    }, {
      borrowerId: 'Borrower3',
      type: 'co-borrower',
      firstName: 'Suzi',
      middleName: 'abc',
      lastName: 'Firstimer',
      suffixName: 'Mr',
      mobile: '',
      email: 'test@test.com',
      employmentAnnualIncomeAmount: 1234567.45,
      jointWith: null,
      maritalStatusType: 'Married',
      domesticRelationshipIndicator: 'No',
      domesticRelationshipType: '',
      domesticRelationshipStateCode: '',
      domesticRelationshipTypeOtherDescription: '',
      selfDeclaredMilitaryServiceIndicator: 'Yes',
      militaryStatusType: 'US Armed Forces',
      militaryServiceToDate: '7/3/2023',
      citizenshipResidencyType: 'unknown',
      fullName: 'Alternate Name',
      dependentCount: 3,
      dependents: [{
        dependentAgeYearsCount: 12
      }, {
        dependentAgeYearsCount: 5
      }, {
        dependentAgeYearsCount: 2
      }],
      alternatePhone: '1234567890',
      ssn: '123456789',
      borrowerBirthDate: '07/23/1967',
      residences: [{
        'type': 'present',
        'borrowerResidencyDurationYearsCount': 10,
        'borrowerResidencyDurationMonthsCount ': 120,
        'street': 'Dawes St',
        'unit': '',
        'cityName': 'Springfield',
        'stateCode': 'Massachusetts',
        'postalCode': '01109',
        'housingExpenseType': 'Rent',
        'housingExpensePaymentAmount': '1000'
      }, {
        'type': 'mail',
        'borrowerResidencyDurationYearsCount': 10,
        'borrowerResidencyDurationMonthsCount ': 120,
        'street': 'Dawes St',
        'unit': '',
        'cityName': 'Springfield',
        'stateCode': 'Massachusetts',
        'postalCode': '01109',
        'housingExpenseType': 'Rent',
        'housingExpensePaymentAmount': '1000'
      }, {
        'type': 'previous',
        'borrowerResidencyDurationYearsCount': 10,
        'borrowerResidencyDurationMonthsCount ': 120,
        'street': 'Dawes St',
        'unit': '',
        'cityName': 'Springfield',
        'stateCode': 'Massachusetts',
        'postalCode': '01109',
        'housingExpenseType': 'Rent',
        'housingExpensePaymentAmount': '1000'
      }, {
        'type': 'previous',
        'borrowerResidencyDurationYearsCount': 10,
        'borrowerResidencyDurationMonthsCount ': 120,
        'street': 'Dawes St',
        'unit': '',
        'cityName': 'Springfield',
        'stateCode': 'Massachusetts',
        'postalCode': '01109',
        'housingExpenseType': 'Rent',
        'housingExpensePaymentAmount': '1000'
      }]
    }],
    subjectProperty: {
      street: 'Dawes St',
      unit: '1',
      cityName: 'Springfield',
      stateCode: 'Massachusetts',
      postalCode: '01109',
      financedUnitCount: '',
      neighborhoodHousingType: 'Single Family Home',
      propertyCurrentUsageType: 'Home Use',
      propertyValuationAmount: 200000,
      attachmentType: 'Attached',
      propertyMixedUsageIndicator: 'Yes',
      propertyStructureBuiltYear: 2013,
      homeownersAssociationDuesPaymentAmount: 500.0
    },
    title: {
      currentTitleOwner: 'Mr. ABC',
      futureTitleOwner: 'Mr. XYZ',
      titleMannerHeld: '',
      indianCountryLandTenure: 'Yes',
      indianCountryLandTenureType: '',
      propertyPartOfTrust: 'Yes',
      trustDetails: ''
    },
    nonBorrowingSpouse: {
      firstName: 'Suzzan',
      middleName: 'abc',
      lastName: 'Firstimer',
      suffixName: 'Mr',
      email: 'test@test.com',
      phone: '',
      address: {
        street: 'Dawes St',
        unit: '',
        cityName: 'Springfield',
        stateCode: 'Massachusetts',
        postalCode: '01109'
      }
    }
  }
};
export const getDeclarations = declarations => {
  return Object.keys(declarations).reduce((r, c) => {
    const obj = Object.assign(r, {
      [c]: isNaN(Number(declarations[c])) || declarations[c] === true || declarations[c] === false ? declarations[c] : isArray(declarations[c]) ? [] : typeof declarations[c] === 'string' ? '' : typeof declarations[c] === 'number' ? 0 : false
    });
    return {
      ...obj,
      purchaseFamilyRelation: null
    };
  }, {});
};
export const normalization = (data, productCode) => {
  const {
    borrowers,
    subjectProperty,
    title,
    nonBorrowingSpouse
  } = data;
  //normalizing borrowers
  const normalizedBorrowers = borrowers.map(borrower => {
    const {
      residences,
      ...rest
    } = borrower;
    const {
      Mailing,
      Current,
      Prior: previous
    } = groupBy(residences, 'type');
    return {
      ...rest,
      residences: {
        mailing: get(Mailing, ['0'], {}),
        present: get(Current, ['0'], []),
        previous: Array.isArray(previous) && previous.length ? previous : []
      },
      declarations: {
        intendToOccupy: null,
        anotherPropertyOwnershipInterest: null,
        typePropertyOwned: '',
        titleHoldType: '',
        purchaseFamilyRelation: null,
        downPaymentBorrowed: null,
        amountOfMoneyBorrower: '',
        anotherPropertyBeforeClosing: null,
        undisclosedNewCredit: null,
        lienSubjectProperty: null,
        undisclosedPropertyMortgageLoan: null,
        outstandingJudgements: null,
        defaultOnFederalDebt: null,
        partyToLawsuit: null,
        propertyTitleForeclosure: null,
        preForeclosureSale: null,
        propertyForeclosed: null,
        declaredBankruptcy: null,
        bankruptcyDeclarationTypeList: [],
        propertyOwnType: null,
        propertyTitleHeld: null,
        obligedToAlimony: null,
        coMakerOrEndorser: null,
        usCitizen: null,
        permanentResidentAlien: null,
        foreclosureOrJudgement: null
      },
      demographic: {
        ethnicity: {
          hispanicOrLatino: false,
          hispanicOrLatinoList: {
            mexican: false,
            puertoRican: false,
            cuban: false,
            other: false,
            enteredOrigin: ''
          },
          noInformationProvided: false,
          notHispanicOrLatino: false
        },
        race: {
          americanIndianOrAlaskaNative: false,
          americanIndianOrAlaskaNativeName: '',
          asian: false,
          asianList: {
            asianIndian: false,
            chinese: false,
            filipino: false,
            japanese: false,
            korean: false,
            vietnamese: false,
            other: false,
            enteredRace: ''
          },
          blackOrAfricanAmerican: false,
          nativeHawaiianOrOtherPacificIslander: false,
          nativeHawaiianOrOtherPacificIslanderList: {
            nativeHawaiian: false,
            guamanianOrChamorro: false,
            samoan: false,
            other: false,
            enteredRace: ''
          },
          white: false,
          noInformationProvided: false
        },
        sex: {
          male: false,
          female: false,
          noInformationProvided: false
        }
      }
    };
  });
  const normalizedsubjectProperty = {
    ...subjectProperty,
    ...(subjectProperty.propertyMixedUsageIndicator ? subjectProperty.propertyMixedUsageIndicator : {
      propertyMixedUsageIndicator: false
    }),
    ...(subjectProperty.financedUnitCount ? {
      financedUnitCount: subjectProperty.financedUnitCount.toString()
    } : {
      financedUnitCount: '0'
    }),
    attachmentType: subjectProperty.attachmentType || ''
  };

  //normalizing property

  const property = Functions.isNBSsectionRequired(borrowers) > 0 ? [normalizedsubjectProperty, title, nonBorrowingSpouse] : [normalizedsubjectProperty, title];

  //update template with flags
  const templateByProductCode = fullAppNavigation[productCode];
  const templateWithFlags = ['borrowers', 'additional', 'property', 'declarations', 'demographic'].reduce((r, c) => {
    const screenInfo = templateByProductCode[c];
    return Object.assign(r, {
      [c]: {
        ...screenInfo,
        flags: Array.from({
          length: c === 'property' ? property.length : borrowers.length
        }, () => c === 'declarations' || c === 'demographic' ? 'INFORMATION REQUIRED' : 'CONFIRM INFO')
      }
    });
  }, {});
  return {
    data: {
      borrowers: normalizedBorrowers,
      property
    },
    template: {
      ...templateWithFlags,
      current: 1,
      previous: 0,
      isEditing: false,
      isRemoving: false,
      modifyingId: undefined,
      screen: 'borrowers'
    }
  };
};
export const deNormalization = (payload, isSubmitted) => {
  const loanNumber = get(payload, ['metadata', 'loanNumber'], '');
  const offerGUID = get(payload, ['metadata', 'offerGUID'], '');
  const referralSource = get(payload, ['metadata', 'referralSource'], '');
  const utmDetails = get(payload, ['metadata', 'utmDetails'], '');
  const product = get(payload, ['metadata', 'product'], '');
  const borrowers = get(payload, ['data', 'borrowers'], []);
  const property = get(payload, ['data', 'property'], []);
  const propertyAddress = property && property.length > 0 ? pick(property[0], ['street', 'unit', 'stateCode', 'cityName', 'postalCode']) : {};
  if (!isEmpty(borrowers) && !isEmpty(property)) {
    var _nbs$address;
    const denormalizedBorrowers = borrowers.map(borrower => {
      const mailing = get(borrower, ['residences', 'mailing'], null);
      const present = get(borrower, ['residences', 'present'], null);
      const previous = get(borrower, ['residences', 'previous'], null);
      let address = [mailing, present];
      if (Array.isArray(previous) && previous.length) {
        previous.forEach(obj => address = [...address, obj]);
      }
      return {
        ...omit(borrower, ['residences']),
        residences: address.filter(each => !isEmpty(each)).map(each => each.sameAsPropertyAddress ? Object.assign(propertyAddress, each) : each),
        declarations: getDeclarations(borrower.declarations)
      };
    });
    const nbs = get(property, ['2'], {
      firstName: null,
      middleName: null,
      lastName: null,
      suffixName: null,
      email: null,
      phone: null,
      address: null
    });
    const normalizedNBS = {
      ...nbs,
      address: (nbs === null || nbs === void 0 || (_nbs$address = nbs.address) === null || _nbs$address === void 0 ? void 0 : _nbs$address.isPropertyAddress) === 'Yes' ? propertyAddress : nbs === null || nbs === void 0 ? void 0 : nbs.address
    };
    return {
      data: {
        isSubmitted: isSubmitted,
        isAbandoned: false,
        loanNumber,
        offerGUID,
        referralSource,
        product,
        utmDetails,
        borrowers: denormalizedBorrowers,
        subjectProperty: get(property, ['0'], null),
        title: get(property, ['1'], null),
        ...(Object.values(normalizedNBS).every(v => v !== null) ? {
          nonBorrowingSpouse: normalizedNBS
        } : {
          nonBorrowingSpouse: {
            firstName: null,
            middleName: null,
            lastName: null,
            suffixName: null,
            email: null,
            phone: null,
            address: null
          }
        })
      }
    };
  }
  return {};
};
//# sourceMappingURL=helpers.js.map